<ng-container *ngIf="policyText">
<div>
  <div class="message-container">
<p id="content" [innerHtml]="policyText | parseFormattedText"></p>

    <div class="actions privacy-ok">
      <button (click)="goBack()" class="form-control btn margin-top" >{{locale.closeButtonText}}</button>
    </div>
  </div>
</div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/components/legal/privacy-policy/privacy-policy.component.html